import React from 'react'
import Swal from 'sweetalert2'
import { PopUpContainer, PopUpHeader, PopUpTitle } from '../confirmationModal/style'
import styled from 'styled-components'
import '../style.css'
import { renderToString } from 'react-dom/server'

const PopUpContent = styled.div`
  padding: 24px 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  height: calc(450px - 53px);
  overflow-y: auto;
`

export interface PublicOrganInfoModalProps {
  title: string
  component: JSX.Element
}

export const showPublicOrganInfoModal = ({ title, component }: PublicOrganInfoModalProps): void => {
  const content = (
    <PopUpContainer>
      <PopUpHeader>
        <PopUpTitle>{title}</PopUpTitle>
      </PopUpHeader>
      <PopUpContent>
        {component}
      </PopUpContent>
    </PopUpContainer>
  )

  Swal.fire({
    showCloseButton: true,
    showConfirmButton: false,
    allowOutsideClick: true,
    customClass: {
      popup: 'public-organ-info-modal',
      closeButton: 'public-organ-info-modal-close',
      container: 'public-organ-info-modal-container'
    },
    html: renderToString(content),
    width: '800px',
    heightAuto: false,
    padding: 0,
    backdrop: 'rgba(0,0,0,0.4)'
  })
}

